import Vue from 'vue'
import { getApiBasePath } from '@/constants'

export const getSwiperImages = async (params) => {
  const ApiBasePath = getApiBasePath()
  const response = await Vue.axios.post(`${ApiBasePath}/gzh/find`, params)
  return response.data
}

export const getBannerInfo = async (params) => {
  const ApiBasePath = getApiBasePath()
  const response = await Vue.axios.post(`${ApiBasePath}/customer/bannerInfo`, params)
  return response.data
}

export const getNameList = async (params) => {
  const ApiBasePath = getApiBasePath()
  const response = await Vue.axios.post(`${ApiBasePath}/customer/myHandleList`, params)
  return response.data
}

export const getNameDetailById = async (params) => {
  const ApiBasePath = getApiBasePath()
  const response = await Vue.axios.post(`${ApiBasePath}/customer/detail`, params)
  return response.data
}

export const saveNameDetail = async (params) => {
  const ApiBasePath = getApiBasePath()
  const response = await Vue.axios.post(`${ApiBasePath}/customer/saveLoan`, params)
  return response.data
}

export const commitStatus = async (params) => {
  const ApiBasePath = getApiBasePath()
  const response = await Vue.axios.post(`${ApiBasePath}/event/commitStatus`, params)
  return response.data
}
